import React, { useState, useRef, useEffect } from "react";
import { cn } from "../../lib";
import { arrowDownIcon } from "../../assets/icons/SvgIconList";

interface IICAccordionProps {
  title: string;
  content: JSX.Element;
}

const ICAccordion: React.FC<IICAccordionProps> = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [height, setHeight] = useState("0px");
  const contentRef = useRef<HTMLDivElement>(null);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (contentRef.current) {
      setHeight(isOpen ? `${contentRef.current.scrollHeight}px` : "0px");
    }
  }, [isOpen]);

  return (
    <div
      className={cn(
        `relative mb-3 overflow-hidden !rounded-t-lg transition-all duration-300 ease-in-out`,
        {
          "bg-accent-emphasis": isOpen,
          "bg-subtle": !isOpen,
        }
      )}
    >
      <div>
        <div
          className={`relative flex items-center w-full p-4 text-left transition-all ease-in border-b cursor-pointer !font-semibold `}
          onClick={toggleAccordion}
        >
          <h5>{title}</h5>
          <div
            className={cn(
              `absolute right-0 pt-1 transition-all grid place-items-center duration-300 pr-4 h-10 w-10`,
              {
                "rotate-180 -translate-x-4": isOpen,
              }
            )}
          >
            {arrowDownIcon}
          </div>
        </div>
      </div>
      <div
        className="overflow-hidden transition-all duration-300 ease-in-out "
        style={{ height }}
      >
        <div ref={contentRef} className="p-4">
          {content}
        </div>
      </div>
    </div>
  );
};

export default ICAccordion;
